import React from 'react';

interface BlobPathRendererProps {
  value: string;
  onPopupCenter: (url: string, title: string, w: number, h: number) => void;
}

const BlobPathRenderer: React.FC<BlobPathRendererProps> = ({
  value,
  onPopupCenter,
}) => {
  let BLOB_SAS_TOKEN = process.env.REACT_APP_BLOB_SAS_TOKEN;
  const handleClick = () => {
    const blobPath = value;
    if (!blobPath) return;

    const fullBlobUrl = `${blobPath}?${BLOB_SAS_TOKEN}`;
    // Open the document in a new window
    onPopupCenter(fullBlobUrl, "Document Viewer", 1100, 550);
  };
  return value ? (
    <button
      style={{
        color: "#007bff",
        textDecoration: "underline",
        cursor: "pointer",
        background: "none",
        border: "none",
        padding: 0,
        font: "inherit",
      }}
      onClick={handleClick}
      aria-label="View blob path"
    >
      BlobPath
    </button>
  ) : (
    <span>Unavailable</span>
  );
};

export default BlobPathRenderer;